import { LegalPage } from './LegalPage';

const sections = [
  {
    title: 'Essential cookies',
    body: [
      'These cookies keep you signed in, remember consent choices, and maintain load balancer sessions. They are required to deliver the candidate, employer, and admin apps.',
    ],
    bullets: [
      'Auth0 session cookies for authentication.',
      'Cloudflare load balancer cookies to route traffic.',
      'Preference cookies that record language and theme choices.',
    ],
  },
  {
    title: 'Analytics & product insight',
    body: [
      'With your consent we use PostHog to understand which features are used and to improve the matching experience. Analytics cookies are never used to build advertising profiles.',
    ],
  },
  {
    title: 'Marketing & third-party embeds',
    body: [
      'On the marketing site (www) we may load Google Tag Manager, GA4, or consented marketing pixels. Inside the jobs app we do not run advertising technologies.',
    ],
  },
  {
    title: 'Managing cookies',
    body: [
      'You can update cookie consent in the notification & privacy settings page or by clearing cookies in your browser. Essential cookies will continue to be set in order to make the service work.',
      'To opt out of analytics you can also enable "Do Not Track" in your browser; Lighthouse honours this signal.',
    ],
  },
];

export function CookiesPage() {
  return (
    <LegalPage
      title="Cookie Notice"
      description="Details about the cookies and tracking technologies used across the Lighthouse marketing site and applications."
      lastUpdated="14 November 2025"
      path="/cookies"
      sections={sections}
    />
  );
}
